import {
  Action_GetDMAttributes,
  Action_GetDMAttributesSuccess,
} from "./actionTypes";
// danh mục group Categorie
export const Index_GetDMAttributes = (data) => ({
  type: Action_GetDMAttributes,
  payload: data
});
export const Index_GetDMAttributesSuccess = (data) => ({
  type: Action_GetDMAttributesSuccess,
  payload: data,
});
